// A click on a post card or preview opens the post: links and buttons in
// it keep their own action, selecting text opens nothing, and ctrl/cmd/
// shift or the middle button open a new tab. True when it opened.
export const openPost = (event, router, statusId) => {
  if (event.type === 'auxclick' && event.button !== 1) return false
  if (event.target.closest('a, button, input, textarea, label')) return false
  if (window.getSelection()?.toString()) return false
  const to = { name: 'conversation', params: { id: statusId } }
  const newTab =
    event.type === 'auxclick' ||
    event.ctrlKey ||
    event.metaKey ||
    event.shiftKey
  if (newTab) {
    window.open(router.resolve(to).href, '_blank')
  } else {
    router.push(to)
  }
  return true
}
